// extracted by mini-css-extract-plugin
export default {"value":"statistics_value__dFJXx"};